"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getFeatureName } from '@autoguru/feature-identification';
import { ENV_NAME, TENANT_NAME } from '@autoguru/global-configs';
export const buildLogContext = (contexts = {}) => {
  return _objectSpread(_objectSpread({}, contexts), {}, {
    featureName: getFeatureName(),
    mfeAppName: __GDU_APP_NAME__,
    ag_env: ENV_NAME,
    ag_tenant: TENANT_NAME
  });
};
export const logEvent = (breadcrumb, agent) => {
  var _breadcrumb$data;
  if (!agent) return;
  const context = buildLogContext();
  agent.addPageAction(breadcrumb.category, _objectSpread({
    type: breadcrumb.type,
    level: breadcrumb.level,
    data: JSON.stringify(breadcrumb.data)
  }, context));
  // Log exceptions if breadcrumb contains errors
  if ((_breadcrumb$data = breadcrumb.data) !== null && _breadcrumb$data !== void 0 && _breadcrumb$data.errors) {
    const errors = breadcrumb.data.errors;
    if (Array.isArray(errors)) {
      for (const error of errors) {
        if (error instanceof Error) {
          agent.noticeError(error, _objectSpread({}, context));
        }
      }
    } else if (errors instanceof Error) {
      agent.noticeError(errors, _objectSpread({}, context));
    }
  }
};